import React from 'react';
import { Link } from 'react-router-dom';

const MenuName = props => (
  <div className="main-menu__name">{props.family.title}</div>
);
const MenuIcon = props => (
  <div className={`main-menu__icon icon icon--${props.family.theme}`} />
);

const MenuOption = props => {
  if (props.family.products.length > 1) {
    return (
      <a
        className="main-menu__option-link"
        onClick={() => props.onMenuClick(props.position)}
      >
        <MenuIcon {...props} />
        <MenuName {...props} />
        <span className="main-menu__arrow" />
      </a>
    );
  }
  return (
    <Link
      to={`/presupuesto/${props.family.path}${props.qparams}`}
      style={{ textDecoration: 'none' }}
      className="main-menu__option-link"
      onClick={() => props.onMenuClick()}
    >
      <MenuIcon {...props} />
      <MenuName {...props} />
    </Link>
  );
};

export default MenuOption;



// WEBPACK FOOTER //
// ./src/components/HorizontalMenu/MenuOption.js